import './CompanyInfo.css';
import { useEffect, useState } from 'react';
import { getCompanySizes, getUserCompany, updateCompany, createCompany, getCompanyIndustries, getAllIndustries, hRefreshToken, refreshToken, searchCompaniesDropdown, hasCompanyEditAccess } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import React from 'react';
import FadeIn from '../../utils/fadein';
import { Helmet } from "react-helmet";
import Spinner from '../../components/layout/Spinner';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import { FaAsterisk } from 'react-icons/fa';

const CompanyInfo = ({ userType }) => {
  const [company, setCompany] = useState({});
  const [companySizes, setCompanySizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState({});
  const [selectedCompanySize, setSelectedCompanySize] = useState(0);
  const [selectedCompanySizeName, setSelectedCompanySizeName] = useState('');
  const [selectedCompanyStage, setSelectedCompanyStage] = useState(0);
  const [selectedIndustry, setSelectedIndustry] = useState(0);
  const [industryName, setIndustryName] = useState('');
  const [newCompanyName, setNewCompanyName] = useState('');
  const [industries, setIndustries] = useState([]);
  const [selectedIndustryId, setSelectedIndustryId] = useState(0);
  const [newCompanyWebsite, setNewCompanyWebsite] = useState('');
  const [showCompanyName, setShowCompanyName] = useState(false);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [query, setQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [hasCompany, setHasCompany] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(0);
  const [hasSellerRole, setHasSellerRole] = useState(false);
  const [isSeller, setIsSeller] = useState(false);
  const [hasEditAccess, setHasEditAccess] = useState(false);
  const [loadedAccess, setLoadedAccess] = useState(false);
  let refSize = React.createRef();

  useEffect(() => {

    async function checkEditAccess() {
      let res = await hasCompanyEditAccess();
      if (res.success) {
        setHasEditAccess(res.data);
      }

      setLoadedAccess(true);
    }

    async function loadData() {
      await loadCompanySizes();

      let result = await getUserCompany();

      if (result.success) {
        let { company_stage_id, name, industry, industry_id } = result.data;

        setCompany(result.data);
        setNewCompanyName(name);
        setNewCompanyWebsite(result.data.website);
        setSelectedCompanySize(result.data.company_size_id);
        setSelectedSize(companySizes.find(item => item.company_size_id === result.data.company_size_id));
        setSelectedCompanyStage(company_stage_id);
        setSelectedIndustry(industry_id);
        setSelectedIndustryId(industry_id);
        setIndustryName(industry);
        setHasSellerRole(result.data.has_seller_role);
        setIsSeller(result.data.is_seller);
        setLoaded(true);
        setHasCompany(true);
      }

      else {
        // no company found
        setHasCompany(false);
        setLoaded(true);
      }
    }

    async function loadCompanySizes() {
      let data = await getCompanySizes();
      if (data.data) {
        setCompanySizes(data.data);
      }
    }

    async function loadIndustries() {
      let data = await getAllIndustries();

      if (data.success) {
        setIndustries(data.data);
      }
    }

    checkEditAccess();
    loadCompanySizes();
    loadData();
    loadIndustries();
  }, []);

  useEffect(() => {
    let found = companySizes.find(item => {
      return item.company_size_id === selectedCompanySize
    });

    if (found) {
      setSelectedCompanySizeName(found.value);
      setSelectedSize(found);
    }

  }, [selectedCompanySize]);

  async function handleSaveCompanyName() {
    let res = await updateCompany({ name: newCompanyName });

    if (res.success) {
      setShowCompanyName(false);
      setCompany({ ...company, name: newCompanyName });

      await hRefreshToken();
      loadSaveBanner();
    }
  }

  async function companySearch(query) {
    let data = await searchCompaniesDropdown(query);

    if (data.data) {
      setCompanies(data.data);
    }
  }

  async function handleNameChange(e) {
    setShowDropdown(true);
    setCompanies([]);
    setSelectedCompany(0);

    setQuery(e.target.value);
    await companySearch(e.target.value);
  }

  async function handleNameClick(id, name) {
    setSelectedCompany(id);
    setShowDropdown(false);
    setQuery(name);
  }

  function loadSaveBanner() {
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function handleSaveCompanyWebsite() {
    let res = await updateCompany({ website: newCompanyWebsite });

    if (res.success) {
      setCompany({ ...company, website: newCompanyWebsite });
      loadSaveBanner();
    }

    else if (res.status === 403) {
      await refresh();
      let res = await updateCompany({ website: newCompanyWebsite });

      if (res.success) {
        setCompany({ ...company, website: newCompanyWebsite });
        loadSaveBanner();
      }
    }
  }

  async function handleSaveCompanyIndustry() {
    let res = await updateCompany({ industry_id: selectedIndustryId });

    if (res.success) {
      setCompany({ ...company, industry_id: selectedIndustryId });
      setCompany({ ...company, industry: industryName });
      loadSaveBanner();
    }

    else if (res.status === 403) {
      await refresh();
      let res = await updateCompany({ industry_id: selectedIndustryId });

      if (res.success) {
        setCompany({ ...company, industry_id: selectedIndustryId });
        setCompany({ ...company, industry: industryName });
        loadSaveBanner();
      }
    }
  }

  async function handleSaveCompanySize() {
    let selected = parseInt(refSize.current.value);

    let res = await updateCompany({ company_size_id: selected });

    if (res.success) {
      setSelectedCompanySize(selected);
      loadSaveBanner();
    }

    else if (res.status === 403) {
      await refresh();
      let res = await updateCompany({ company_size_id: selected });

      if (res.success) {
        setSelectedCompanySize(selected);
        loadSaveBanner();
      }
    }
  }

  async function addUserCompany() {
    // save new company
    if (query.length > 0) {
      let result = await createCompany(query);

      if (result.success) {
        window.location = window.location;
      }
    }

    else {
      alert("Must enter a valid company name");
    }
  }

  async function handleSaveCompany() {
    if (newCompanyName.length === 0) {
      alert("Company name is required.");
      return;
    }

    if (selectedCompanySize == 0) {
      alert("Company size is required.");
      return;
    }

    if (newCompanyWebsite.length === 0) {
      alert("Company website is required.");
      return;
    }

    let data = {
      name: newCompanyName,
      company_size_id: selectedCompanySize,
      industry_id: selectedIndustryId,
      website: newCompanyWebsite
    };

    let res = await updateCompany(data);

    if (res.success) {
      setCompany({ ...company, name: newCompanyName, company_size_id: selectedCompanySize, industry_id: selectedIndustryId, website: newCompanyWebsite });
      loadSaveBanner();
    }
  }

  return (
    <div className="companyedit">
      <Helmet>
        <meta name="description" content="" />
      </Helmet>
<div className="mb-6">
        <Link 
          className='inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 ease-in-out'
          to="/account/home"
        >
          <span className="mr-2">←</span>
          Back
        </Link>
      </div>      <div className="account__header">Company Information</div>

      <p className='account__description'>
        Keep your company info up to date.
      </p>

      {loaded === false && (
        <>
          <Spinner />
        </>
      )}

      {loaded && hasCompany && (
        <>
          <div className='companyedit__form'>
            {/* <div style={{ textAlign: 'right', fontSize: '12px', fontStyle: 'italic', marginBottom: '10px', color: 'tomato' }}><FaAsterisk /> Required fields</div> */}

            <div className="accountinfo__form-group">
              <div>
                <div className="accountinfo__form-group-title">Company Name</div>
              </div>

              <div className="">
                <div className="">
                  <input type="text" id="txtCompanyName" className="input" value={newCompanyName} onChange={event => { setNewCompanyName(event.target.value); }} />
                </div>

                <div className='mt-4'>
                  <div className="accountinfo__form-group-title">Company Size</div>

                  <select
                    className="input-box dropdown-font"
                    type='text'
                    ref={refSize}
                    value={selectedCompanySize}
                    onChange={(e) => setSelectedCompanySize(e.target.value)}
                    name='companysize'
                    placeholder='Enter company size'
                    required
                  >
                    <option value={0}>Select company size</option>
                    {companySizes.length > 0 && (
                      companySizes.map((item, index) => (
                        <option key={index} value={item.company_size_id}>
                          {item.value}
                        </option>
                      ))
                    )}
                  </select>
                </div>

                <div className='mt-4'>
                  <div className="accountinfo__form-group-title">Industry</div>

                  <div className="form-group">
                    <select className='input select' value={selectedIndustryId} onChange={(e) => setSelectedIndustryId(e.target.value)}>
                      <option value="0">Select industry...</option>
                      {industries.map(item => (
                        <>
                          <option value={item.industry_id}>{item.name}</option>
                        </>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='mt-4'>
                  <div className="accountinfo__form-group-title">Company Website</div>


                  <div className="form-group">
                    <input type="text" id="txtCompanyWebsite" className="input" value={newCompanyWebsite} onChange={event => { setNewCompanyWebsite(event.target.value); }} placeholder="Your company's website" />
                  </div>
                </div>
              </div>

              <div className='mt-2'>
                {hasEditAccess ? (
                  <button className='inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed' onClick={() => handleSaveCompany()}>
                    Update
                  </button>
                ) : (
                  <div className="text-sm text-red-600 bg-red-100 p-3 rounded-lg">
                    You must have administrator privileges to update company information.
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {loaded && hasCompany === false && (
        <>
          <h3>Enter your companies name or select from the dropdown</h3>
          <div>
            <div className='form-group'>
              <label className="label input-label" htmlFor='txtName'>Company name</label>
              <input type="text" id='txtName' className="input" onChange={handleNameChange} placeholder="Enter here" value={query} required></input>
            </div>

            {companies.length > 0 && showDropdown && (
              <div className="selectrole__company-dropdown-wrapper" style={{ width: "40%" }}>
                <div className="selectrole__company-dropdown">
                  {companies.map((item, index) => (
                    <div key={index} onClick={() => handleNameClick(item.company_id, item.name)} className="selectrole__company-dropdown-item" id={"company_" + item.company_id}>{item.name}</div>
                  ))}
                </div>
              </div>
            )}

            <div>
              <button className='btn btn--primary' onClick={() => addUserCompany()}>Save</button>
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </div>
  )
}

export default CompanyInfo;